/**
 * Option chooser bentos.
 *
 * Delegated, so it covers every pick group on the page without per-module wiring.
 * The selected label is written into the hidden field named by `data-target`, which on
 * a Gravity Form is the field the submission actually carries.
 */
export default function picks() {
    document.addEventListener('click', function (event) {
        var pick = event.target.closest('.pick');
        if (!pick) { return; }

        var selector = pick.dataset.target;
        var target = selector && document.querySelector(selector);
        var group = selector
            ? document.querySelectorAll('.pick[data-target="' + selector + '"]')
            : pick.parentElement
              ? pick.parentElement.querySelectorAll('.pick')
              : [];

        for (var i = 0; i < group.length; i++) {
            group[i].setAttribute('aria-pressed', group[i] === pick ? 'true' : 'false');
        }

        if (target) {
            target.value = pick.dataset.label || pick.textContent.trim();
            target.dispatchEvent(new Event('change', { bubbles: true }));
        }

        if (pick.dataset.hash) { history.replaceState(null, '', '#' + pick.dataset.hash); }
    });
}
